import React from 'react';

const Footer = () => {
  return (
    <footer className="app-footer">
      <p>© {new Date().getFullYear()} SLC Movie Night. All rights reserved.</p>
      <p>Enjoy the show!</p>
    </footer>
  );
};

export default Footer;